import Machinery from './machinery';
export default Machinery;
